var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53514 4.63877L9.99681 4.07056C10.1746 3.8518 10.4841 3.82587 10.6984 4C10.9064 4.16904 10.9461 4.48805 10.7729 4.70116L4.89995 11.9294C4.7222 12.1482 4.4127 12.1741 4.19838 12C3.99033 11.831 3.95068 11.512 4.12383 11.2989L4.53688 10.7905C2.49595 9.9488 1.24358 8.65833 1.24358 8.65833C0.832693 8.29474 0.821363 7.7016 1.24358 7.34168C1.24358 7.34168 4.00134 4.5 8.00134 4.5C8.53606 4.5 9.04853 4.55079 9.53514 4.63877ZM11.4093 5.18669C13.4823 6.02764 14.7563 7.34168 14.7563 7.34168C15.1668 7.70526 15.1781 8.29841 14.7563 8.65833C14.7563 8.65833 12.0013 11.5 8.00134 11.5C7.43154 11.5 6.88694 11.4423 6.37193 11.3434L7.1757 10.3611C7.43368 10.4511 7.71092 10.5 7.9996 10.5C9.38031 10.5 10.4996 9.38072 10.4996 8C10.4996 7.53433 10.3723 7.0984 10.1506 6.72512L11.4093 5.18669ZM7.8838 9.4956L9.44289 7.59004C9.47983 7.72035 9.4996 7.85787 9.4996 8C9.4996 8.82843 8.82803 9.5 7.9996 9.5C7.96064 9.5 7.92202 9.49852 7.8838 9.4956Z",
    fill: "#333333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.930de04f96c67476720c8a9c7a3cbb94.svg";
export { ForwardRef as ReactComponent };